import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TaskDoneIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.58 18.2V19.84H5.42V4.08H10.26C10.44 3.28 11.14 2.68 12 2.68C12.86 2.68 13.56 3.28 13.74 4.08H18.58V13.94H16.94V5.72H14.94V6.72H9.06V5.72H7.06V18.2H12.58ZM8.66 11.62L9.76 10.48L11.6 12.2L14.54 9.28L15.68 10.4L11.66 14.38L8.66 11.62ZM17.66 22.58C15.66 22.58 14.06 20.98 14.06 19.02C14.06 17.06 15.66 15.46 17.66 15.46C19.66 15.46 21.26 17.06 21.26 19.02C21.26 20.98 19.66 22.58 17.66 22.58ZM17.08 20.94H18.24V19.58H19.6V18.42H18.24V17.06H17.08V18.42H15.72V19.58H17.08V20.94Z" />
    </SvgIcon>
  );
});
